import React from "react";
import { Box, Typography } from "@material-ui/core";

/**
 * Vista previa de lo que el visitante ve DESPUÉS de enviar el formulario —
 * pestaña "Configuración" (mejora post-MVP, 2026-09-19, a pedido del
 * propietario: si "Campos y estilo" tiene vista previa, "Configuración"
 * también debe tenerla, porque ahí vive información igual de importante
 * para lo que el visitante experimenta).
 *
 * Replica el mismo momento que `embed.js` produce de verdad tras un envío
 * exitoso (`views/embedScript.ts`): el formulario se oculta, aparece el
 * mensaje de confirmación y, si hay `redirectUrl`, un BOTÓN de acción — ya
 * no un redirect automático en silencio (2026-09-19: el propietario probó
 * la primera versión en el navegador y no invitaba a ninguna acción).
 * Reutiliza los colores de `styleJson` para que se vea como la MISMA
 * tarjeta que "Campos y estilo", solo que en su estado posterior al envío.
 */
const ConfirmationPreview = ({
  confirmationMessage,
  redirectUrl,
  redirectButtonLabel,
  ctaMode,
  autoRedirect,
  styleJson
}) => {
  const style = styleJson || {};
  const backgroundColor = style.backgroundColor || "#ffffff";
  const borderColor = style.borderColor || "#e2e2e2";
  const buttonColor = style.buttonColor || "#25D366";
  const fontFamily = style.fontFamily || "system-ui, -apple-system, sans-serif";
  const message = confirmationMessage?.trim() || "¡Gracias! Te contactaremos pronto.";
  const textAlign = style.confirmationAlign || "left";
  const isWhatsappCta = ctaMode === "whatsapp";
  const isAutoRedirect = !isWhatsappCta && !!autoRedirect && !!redirectUrl;
  const showButton = !isAutoRedirect && (isWhatsappCta || !!redirectUrl);

  if (isAutoRedirect) {
    return (
      <Box>
        <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
          Así lo verá el visitante después de enviar
        </Typography>
        <Box
          style={{
            background: "#f0f0f3",
            borderRadius: 12,
            padding: 20,
            textAlign: "center"
          }}
        >
          <Typography variant="body2" color="textSecondary">
            El visitante nunca ve esta tarjeta — se redirige de inmediato a:
            <br />
            <strong>{redirectUrl}</strong>
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
        Así lo verá el visitante después de enviar
      </Typography>
      <Box
        style={{
          background: "#f0f0f3",
          borderRadius: 12,
          padding: 20,
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Box
          style={{
            padding: 16,
            background: backgroundColor,
            border: `1px solid ${borderColor}`,
            borderRadius: 8,
            width: "100%",
            maxWidth: 360,
            fontFamily,
            fontSize: 14,
            color: "#222",
            textAlign
          }}
        >
          {style.logoUrl && (
            <img
              src={style.logoUrl}
              alt="Logo"
              style={{ maxHeight: 48, maxWidth: "100%", objectFit: "contain", marginBottom: 8 }}
            />
          )}
          <Box
            style={{
              fontWeight: style.confirmationBold ? 700 : 400,
              fontStyle: style.confirmationItalic ? "italic" : "normal"
            }}
          >
            {message}
          </Box>
          {showButton && (
            <button
              type="button"
              disabled
              style={{
                marginTop: 12,
                padding: "10px 14px",
                border: "none",
                borderRadius: 6,
                fontSize: 14,
                fontWeight: 600,
                fontFamily: "inherit",
                background: buttonColor,
                color: "#ffffff",
                cursor: "default"
              }}
            >
              {redirectButtonLabel?.trim() || (isWhatsappCta ? "Conversar por WhatsApp" : "Continuar")}
            </button>
          )}
        </Box>
      </Box>
      {showButton && (
        <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 8 }}>
          {isWhatsappCta
            ? "Al hacer clic, se abre WhatsApp con el nombre, servicio y fecha que el visitante escribió."
            : `Al hacer clic, el visitante va a: ${redirectUrl}`}
        </Typography>
      )}
    </Box>
  );
};

export default ConfirmationPreview;
